import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { api, type user_overview } from '../api'
import { format_timestamp } from '../format'

export function UsersPage() {
  const [users, set_users] = useState<user_overview[]>([])
  const [name, set_name] = useState('')
  const [email, set_email] = useState('')
  const [error, set_error] = useState<string | null>(null)
  const [busy, set_busy] = useState(false)

  async function load() {
    set_users(await api.list_users())
  }

  useEffect(() => {
    void load()
  }, [])

  async function create(event: React.FormEvent) {
    event.preventDefault()
    set_busy(true)
    set_error(null)
    try {
      await api.create_user(name, email)
      set_name('')
      set_email('')
      await load()
    } catch (caught) {
      set_error(caught instanceof Error ? caught.message : String(caught))
    } finally {
      set_busy(false)
    }
  }

  return (
    <div className="page">
      <h1>Benutzer</h1>
      {error && <div className="notice notice--error">{error}</div>}

      <form className="card" onSubmit={create}>
        <h2>Neuen Benutzer anlegen</h2>
        <div className="row">
          <div className="field" style={{ flex: 1, minWidth: 200 }}>
            <label htmlFor="name">Name</label>
            <input
              id="name"
              type="text"
              value={name}
              onChange={(event) => set_name(event.target.value)}
            />
          </div>
          <div className="field" style={{ flex: 1, minWidth: 240 }}>
            <label htmlFor="email">E-Mail</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(event) => set_email(event.target.value)}
            />
          </div>
          <button className="primary" type="submit" disabled={busy || !name || !email}>
            Anlegen
          </button>
        </div>
        <p className="small muted">
          Benutzer werden nie automatisch aus einer CSV angelegt: ein Tippfehler in der Adresse
          würde einen Anmeldelink an eine fremde Person schicken.
        </p>
      </form>

      <div className="card">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>E-Mail</th>
              <th>Zu erledigen</th>
              <th>Zu prüfen</th>
              <th>Erinnerung</th>
              <th>Letzte Erinnerung</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.id}>
                <td>
                  <Link to={`/admin/benutzer/${user.id}`}>{user.name}</Link>
                </td>
                <td className="muted">{user.email}</td>
                <td>{user.reminderable_count}</td>
                <td>{user.pending_review_count > 0 ? <strong>{user.pending_review_count}</strong> : 0}</td>
                <td className="small">
                  {user.reminders_paused ? (
                    <span className="status status--none">ausgesetzt</span>
                  ) : (
                    `alle ${user.reminder_interval_days} Tage`
                  )}
                </td>
                <td className="small muted">
                  {user.last_reminder_sent_at ? format_timestamp(user.last_reminder_sent_at) : '—'}
                </td>
              </tr>
            ))}
            {users.length === 0 && (
              <tr>
                <td colSpan={6} className="muted">
                  Noch keine Benutzer angelegt.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}
